import { render, staticRenderFns } from "./knowledge-learn.vue?vue&type=template&id=0349e469&scoped=true"
import script from "./knowledge-learn.vue?vue&type=script&lang=js"
export * from "./knowledge-learn.vue?vue&type=script&lang=js"
import style0 from "./knowledge-learn.vue?vue&type=style&index=0&id=0349e469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349e469",
  null
  
)

export default component.exports